import { render, staticRenderFns } from "./carouselForm.vue?vue&type=template&id=bd3aa5fe"
import script from "./carouselForm.vue?vue&type=script&lang=js"
export * from "./carouselForm.vue?vue&type=script&lang=js"
import style0 from "./carouselForm.vue?vue&type=style&index=0&id=bd3aa5fe&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports